import { TStringField } from '../../../types/sitecore.types';
import { TMediaGalleryParams, TMediaGalleryProps } from '../types/mediaGallery.types';
import { TGalleryItem } from '../../../types/media.types';
import { getImageField } from '../../../utils/getImageFields';
import { getThumbnailProps } from '../../../utils/youtube.utils';
import { THeadingTag } from '../../../types/types';

export class MediaGalleryModel {
  private readonly fields?;
  private readonly params?: TMediaGalleryParams;

  constructor(props: TMediaGalleryProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || undefined;
  }

  get slides(): Array<TGalleryItem> {
    if (this.fields?.items?.length > 0) {
      return this.fields?.items?.map((item) => {
        const { thumbnailImgSrc } = getThumbnailProps(item.fields?.video?.value?.href || '');

        return {
          id: item.id ?? item.dataSource,
          title: item.fields?.videoHeading,
          description: item.fields?.videoSubheading,
          desktopImage: getImageField(item.fields?.image, thumbnailImgSrc || '', item.fields?.useVideo?.value),
          mobileImage: getImageField(item.fields?.mobileImage, thumbnailImgSrc || '', item.fields?.useVideo?.value),
          fullImage: getImageField(item.fields?.image, thumbnailImgSrc || '', item.fields?.useVideo?.value),
          desktopTransformation: 'Size1200',
          tabletTransformation: 'Size500',
          mobileTransformation: 'Size500',
          desktopAlt: item.fields?.image?.value?.alt,
          mobileAlt: item.fields?.mobileImage?.value?.alt,
          isVideo: item.fields?.useVideo?.value,
          videoUrl: item.fields?.video?.value?.href,
        };
      });
    }
    return [];
  }

  get eyebrow(): TStringField {
    return this.fields?.eyebrow;
  }

  get title(): TStringField {
    return this.fields?.title;
  }

  get description(): TStringField {
    return this.fields?.description;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
